import { getField, updateField } from 'vuex-map-fields';
import notifier from '../helpers/notifier.js';

export default {
  namespaced: true,

  state: () => ({
    partners: [],
    partner: null,
    initialPartner: null,
    filters: {
      partner: null,
      per_page: 10,
    },
  }),

  actions: {
    getPartners: ({ commit }) =>
      axios.get('/partners', { params: {} })
        .then(({ data }) => {
          commit('setPartners', { partners: data });
        }).catch(error => notifier.failed(error)),
  },

  mutations: {
    setPartners: (state, { partners }) => state.partners = partners,
    setPartner: (state, { partner }) => state.partner = partner,
    setInitialPartner: (state, { partner }) => {
      state.partner = partner;
    },
    setFilters: (state, { filters }) => state.filters = filters,
    updateField,
  },

  getters: {
    partners: ({ partners }) => partners,
    filters: ({ filters }) => filters,
    initialPartner: ({ initialPartner }) => initialPartner,
    partnerDropdownOptions: ({ partners }) => partners.map(partner => ({ value: partner.uuid, text: partner.name })),
    getField,
  },
};
